$('.text-with-images-slider').flickity({
  // options
  cellAlign: 'left',
  contain: true
});
if($(window).width() <= 1100) {
  $('.split-announcement-bar-inner-row').flickity({
    // options
    cellAlign: 'left',
    contain: true,
    prevNextButtons: false,
    pageDots: false,
    autoPlay: true
  });
}